<template>
  <SingleSQ
    :questionData="questionData"
    :btnWidth="350"
    :oneOption="false"
    :pendingOption="true"
    :sq_numberData="'sq_thirtyFourData'"
    :sqOptions="[]"
    :secondRadioB="false"
    @goBackInScoringHistory="goBackInScoringHistory">
  </SingleSQ>
</template>

<script>
import SingleSQ from '@/components/savings/blocks/SingleSQ'

export default {
  name: 'SQuesThirtyFour',
  components: {
    SingleSQ
  },
  props: {
    questionData: Object
  },
  methods: {
    setData () {
      this.$emit('handleProgress', 74)
    },
    goBackInScoringHistory () {
      this.$emit('goBackInScoringHistory')
    }
  },
  mounted () {
    this.setData()
  }
}
</script>
